import React from 'react';
import { MessageCircle, Facebook, Link2 } from 'lucide-react';
import { copyText } from '../lib/helpers';

const open = (url) => window.open(url, '_blank', 'noopener,noreferrer,width=680,height=620');

// Simple lettered badge for Pinterest (no brand asset)
const PBadge = () => (
  <span className="w-4 h-4 rounded-full bg-white text-[#e60023] text-[11px] font-bold leading-4 text-center inline-block">P</span>
);

export default function ShareButtons({ title, image, lang = 'en', compact = false }) {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const imageUrl = image && url ? new URL(image, url).href : '';
  const L = lang === 'fr'
    ? { label: 'Partager cet article', copy: 'Copier le lien', copied: 'Lien copié !' }
    : { label: 'Share this article', copy: 'Copy link', copied: 'Link copied!' };
  const e = encodeURIComponent;

  const buttons = [
    { id: 'whatsapp', name: 'WhatsApp', cls: 'bg-[#25d366] hover:bg-[#1eb957]', icon: <MessageCircle className="w-4 h-4" />, go: () => open(`https://wa.me/?text=${e(`${title} ${url}`)}`) },
    { id: 'facebook', name: 'Facebook', cls: 'bg-[#1877f2] hover:bg-[#0f63d1]', icon: <Facebook className="w-4 h-4" />, go: () => open(`https://www.facebook.com/sharer/sharer.php?u=${e(url)}`) },
    { id: 'pinterest', name: 'Pinterest', cls: 'bg-[#e60023] hover:bg-[#c2001d]', icon: <PBadge />, go: () => open(`https://pinterest.com/pin/create/button/?url=${e(url)}&media=${e(imageUrl)}&description=${e(title)}`) },
  ];

  return (
    <div className={`not-prose ${compact ? '' : 'mt-8 pt-6 border-t border-slate-100'}`} data-testid="share-buttons">
      {!compact && <p className="!mb-3 text-[14px] font-semibold text-slate-800">{L.label}</p>}
      <div className="flex flex-wrap gap-2">
        {buttons.map((b) => (
          <button key={b.id} onClick={b.go} className={`inline-flex items-center gap-2 text-white text-[13px] font-medium px-3.5 py-2 rounded-md shadow-sm transition-colors ${b.cls}`} data-testid={`share-${b.id}`} aria-label={b.name}>
            {b.icon}{!compact && b.name}
          </button>
        ))}
        <button onClick={() => copyText(url, L.copied)} className="inline-flex items-center gap-2 text-[13px] font-medium px-3.5 py-2 rounded-md border border-slate-200 bg-white text-slate-700 hover:border-slate-400 transition-colors" data-testid="share-copy-link" aria-label={L.copy}>
          <Link2 className="w-4 h-4" />{!compact && L.copy}
        </button>
      </div>
    </div>
  );
}
